<template>
  <ul :class="[expanded ? 'open' : '', 'nav flex-column']">
    <MenuItem
      v-for="item in menuItems"
      :key="item.id"
      :menuItem="item"
      :rootPageId="rootPageId"
      :currentPageId="currentPageId"
      :currentActiveId="currentActiveId"
      :parentId="parentId"
      :path="path"
      :baseApiUrl="baseApiUrl"
      :level="currentLevel"
      :showLinksText="showLinksText"
      @setActiveLink="setActiveLink"
    ></MenuItem>
  </ul>
</template>
<script>
import MenuItem from "./MenuItem.vue";
export default {
  name: "MenuList",
  props: {
    baseApiUrl: String,
    menuItems: Array,
    rootPageId: Number,
    currentPageId: Number,
    currentActiveId: Number,
    parentId: Number,
    path: Array,
    level: Number,
    showLinksText: String,
    expanded: Boolean,
  },
  emits: {
    setActiveLink: null,
    loadPartialView: null,
  },
  data: function () {
    return {
      currentLevel: this.level,
    };
  },
  components: {
    MenuItem,
  },
  beforeMount() {
    this.currentLevel++;
  },
  methods: {
    setActiveLink: function (id, parentId, target) {
      this.$emit("setActiveLink", id, parentId, target);
    },
  },
};
</script>
